import { HttpClient } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import { global } from '../app.settings';
import { UserDetails } from './user-details.model';


@Injectable()
export class UserService {

  public onOpenChangePasswordDialog: EventEmitter<any> = new EventEmitter<any>();
  private _userDetails: UserDetails;

  private _userDetailsSubject: ReplaySubject<UserDetails>;

  public get userDetails(): UserDetails {
    return this._userDetails;
  }

  constructor(private http: HttpClient
  ) {
    this._userDetailsSubject = new ReplaySubject<UserDetails>(1);
    this.initUserDetails();
  }

  private initUserDetails() {
    this.http.get<UserDetails>(global.apiUrl + 'user-access/user-details').subscribe(userDetails => {
      this._userDetails = userDetails;
      this._userDetailsSubject.next(this._userDetails);
    });
  }

  public logout(): Observable<any> {
    return this.http.get<any>(global.apiUrl + 'user-access/logout')
      .do(response => {
        const redirectUrl = response && response.redirectUrl ? response.redirectUrl : '/Login.aspx';
        window.location.href = redirectUrl;
      });
  }

  public refreshUserDetails() {
    this.initUserDetails();
  }

  public renewSession(): Observable<{ authTokenExpiration: number }> {
    return this.http.post<{ authTokenExpiration: number }>(global.apiUrl + 'user-access/renew-session', {});
  }

  public subscribeToUserDetails(): Observable<UserDetails> {
    return this._userDetailsSubject.asObservable();
  }

  public changePassword(passwords: any): Observable<any> {
    return this.http.post<any>(global.apiUrl + 'user/change-password', passwords);
  }

  public getUserGuide(): Observable<any> {
    return this.http.get(global.apiUrl + 'user-guide',
      { observe: 'response', responseType: 'arraybuffer' });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/user/user.service.ts